var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.$store.getters['showMore/IS_SHOW'])?_c('custom-button',{staticClass:"mt-3",attrs:{"disable":_vm.$store.getters['showMore/IS_ACTION']},on:{"click":_vm.showMore}},[_vm._v(_vm._s(_vm.$tc(_vm.$translate.ShowMore)))]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }